import { Application } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import "@hotwired/turbo-rails";
import { registerControllers } from "stimulus-vite-helpers";

import "./events/event-listeners";
import "./helpers/carousel";
// @ts-ignore
import { carouselise } from "./helpers/carouselise";
import "./helpers/image";
import "./helpers/scrollspy";
import "./helpers/tab-container";
import toggleContent from "./helpers/toggle_content";
import "./helpers/video-gallery";
import "./styles/main.pcss";

Turbo.session.drive = false;

const Stimulus = Application.start();
const controllers = import.meta.glob("./controllers/**/*.ts", { eager: true });

registerControllers(Stimulus, controllers);

document.addEventListener("DOMContentLoaded", () => {
  carouselise();
  toggleContent(document);
});
